import React from 'react';
import './CancellationRequestSection.css';
const CancellationRequestSection = () => {

  return (
    <>
      <div className="row justify-content-center my-3">
        <div className="col-12 text-center">
          <div className="total-div request-body">
            <p className="fw-bold fs-5 submit-text m-0">
              <span>Your request to{' '}
              <span style={{ color: 'red', display: 'inline' }}>cancel</span> your
              policy has been submitted.</span>
            </p>
            <p className="fw-bold margin-correction submit-text">
              Please note: All cancellations will be reviewed by underwriting. You
              will receive an email with an update on the status of your billing
              after your policy has been reviewed.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default CancellationRequestSection;

